export function findCategoryById (categories, id) {
  for (const category of categories) {
    if (category.id === id) {
      return category;
    }

    if (category.children) {
      const childMatchCategory = findCategoryById(category.children, id);
      if (childMatchCategory) {
        return childMatchCategory;
      }
    }
  }

  return null;
}
